import { keys } from "@definitions/index";

export const useKeys = () => {
  return {
    keys,
  };
};
